import baseRoute from '../baseRoute';

export default `${baseRoute}/equipment` as const;
